import view from "abstractions/barba-view";
import liveSearch from "controllers/live-search";
import lozad from "controllers/lozad";
import photoswipe from "controllers/photoswipe";
import lineClamp from "controllers/line-clamp";
import cartRecap from "controllers/cart-recap";

export default view("default|home|search|list.pages|preview.shops", {
  onEnterCompleted: (refs) => {
    // Register components in the lifecycle of the view
    refs.lineClamp = lineClamp();
    refs.cartRecap = cartRecap();
    refs.lozad = lozad();
    refs.liveSearch = liveSearch({
      input: document.querySelector(".filters__search-input"),
      elements: document.querySelectorAll(".card"),
    });
    refs.photoswipe = photoswipe({
      gallerySelector: ".article__gallery",
    });
    Array.from(document.getElementsByClassName("repli--content")).forEach(
      (item) => item.classList.add("is--invisible")
    );
  },
});
